import React, { Component } from "react";

import normaliseCode from "../../utils/normaliseCode";
import normaliseHtml from "../../utils/normaliseHtml";
import htmlToPlain from "../../utils/htmlToPlain";
import getIndent from "../../utils/getIndent";
import selectionRange from "../../vendor/selection-range";
import { prismCss } from "../../utils/prism";

import "../prismStyles.css";

class CssEditor extends Component {
  state = { html: "" };

  onRef = node => (this.ref = node);

  getPlain = () => {
    if (this._innerHTML === this.ref.innerHTML) return this._plain;

    const plain = htmlToPlain(normaliseHtml(this.ref.innerHTML));

    this._plain = plain;
    this._innerHTML = this.ref.innerHTML;

    return this._plain;
  };

  onKeyDown = e => {
    if (e.keyCode === 9) {
      // Tab Key
      document.execCommand("insertHTML", false, "&#009");
      e.preventDefault();
    } else if (e.keyCode === 13) {
      // Enter Key
      const { start: cursorPos } = selectionRange(this.ref);
      const indentation = getIndent(this.getPlain(), cursorPos);

      document.execCommand("insertHTML", false, "\n" + indentation);
      e.preventDefault();
    }
  };

  onKeyUp = e => {
    if (
      e.keyCode === 91 || // left cmd
      e.keyCode === 93 || // right cmd
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    this.selection = selectionRange(this.ref);

    if (
      e.keyCode !== 37 && // left
      e.keyCode !== 38 && // up
      e.keyCode !== 39 && // right
      e.keyCode !== 40 // down
    ) {
      const plain = this.getPlain();
      this.updateContent(plain);
    }
  };

  updateContent = plain => {
    this.setState({ html: prismCss(plain) });
    this.props.onChange(plain);
  };

  componentWillMount() {
    const { code } = this.props;
    const html = prismCss(normaliseCode(code));
    this.setState({ html });
  }

  componentWillReceiveProps({ code }) {
    if (code !== this.props.code) {
      const html = prismCss(normaliseCode(code));
      this.setState({ html });
    }
  }

  shouldComponentUpdate({ code }) {
    return code === this.props.code ? false : true;
  }

  componentDidUpdate() {
    const { selection } = this;
    if (selection) {
      selectionRange(this.ref, selection);
    }
  }

  render() {
    const { html } = this.state;

    return (
      <pre
        ref={this.onRef}
        className="prism-code"
        contentEditable={true}
        dangerouslySetInnerHTML={{ __html: html }}
        onKeyDown={this.onKeyDown}
        onKeyUp={this.onKeyUp}
      />
    );
  }
}

export default CssEditor;



// WEBPACK FOOTER //
// ./src/book/editors/CssEditor.js